/**
 * In-platform analytics tracker.
 *
 * Sends events to POST /api/analytics/track. Auth is optional so we also capture
 * anonymous visitors. A session_id is generated in localStorage on first use.
 *
 * Usage:
 *   import { track, trackPageView } from '../utils/analytics';
 *   track('subscribe_click', { plan: 'pro_monthly' });
 *   trackPageView('/ai-redesign');  // automatically called by AnalyticsListener
 */
import api from './api';

const SESSION_KEY = 'mh_session_id';

function ensureSessionId() {
  let s = null;
  try { s = localStorage.getItem(SESSION_KEY); } catch { /* ignore */ }
  if (!s) {
    s = 'sess_' + Math.random().toString(36).slice(2, 10) + Date.now().toString(36);
    try { localStorage.setItem(SESSION_KEY, s); } catch { /* ignore */ }
  }
  return s;
}

export function track(event, metadata) {
  try {
    api.post('/api/analytics/track', {
      event: String(event).slice(0, 64),
      path: window.location.pathname + window.location.search,
      session_id: ensureSessionId(),
      metadata: metadata || {},
    }).catch(() => {});
  } catch { /* never let analytics break the app */ }
}

export function trackPageView(path) {
  track('page_view', { path: path || window.location.pathname });
}
